
import { useState } from "react";
import { PrintsTable } from "./PrintsTable";
import { PrintDetailsDialog } from "./PrintDetailsDialog";
import { SmartPagination } from "@/components/ui/smart-pagination";

interface PrintsListProps {
  prints: any[];
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function PrintsList({ prints, currentPage, totalPages, onPageChange }: PrintsListProps) {
  const [selectedPrint, setSelectedPrint] = useState<any | null>(null);

  return (
    <div className="space-y-4">
      <PrintsTable 
        prints={prints} 
        onPrintClick={setSelectedPrint}
      />

      <PrintDetailsDialog
        print={selectedPrint}
        open={!!selectedPrint}
        onOpenChange={(open) => !open && setSelectedPrint(null)}
      />

      <SmartPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        className="justify-center"
      />
    </div>
  );
}
